class PriceRange extends HTMLElement {
  #abortController;
  connectedCallback() {
    this.#abortController = new AbortController();
    this.init();
    this.attachEventListeners();
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  init() {
    this.rangeLowerBound = this.querySelector(".js-range__min");
    this.rangeHigherBound = this.querySelector(".js-range__max");
    this.textInputLowerBound = this.querySelector(".js-range-input__min");
    this.textInputHigherBound = this.querySelector(".js-range-input__max");
    this.facetFiltersForm = this.closest("facet-filters-form");
  }

  attachEventListeners() {
    this.textInputLowerBound.addEventListener(
      "change",
      this.handleTextInputChange.bind(this, "min"),
      {
        signal: this.#abortController.signal,
      }
    );
    this.textInputHigherBound.addEventListener(
      "change",
      this.handleTextInputChange.bind(this, "max"),
      {
        signal: this.#abortController.signal,
      }
    );

    this.rangeLowerBound.addEventListener(
      "change",
      this.handleRangeChange.bind(this, "min"),
      {
        signal: this.#abortController.signal,
      }
    );
    this.rangeHigherBound.addEventListener(
      "change",
      this.handleRangeChange.bind(this, "max"),
      {
        signal: this.#abortController.signal,
      }
    );

    this.rangeLowerBound.addEventListener(
      "input",
      this.handleRangeInput.bind(this, "min"),
      {
        signal: this.#abortController.signal,
      }
    );
    this.rangeHigherBound.addEventListener(
      "input",
      this.handleRangeInput.bind(this, "max"),
      {
        signal: this.#abortController.signal,
      }
    );
  }

  handleTextInputChange(type, event) {
    event.preventDefault();
    const isMin = type === "min";
    const textInput = isMin
      ? this.textInputLowerBound
      : this.textInputHigherBound;
    const otherTextInput = isMin
      ? this.textInputHigherBound
      : this.textInputLowerBound;
    const rangeInput = isMin ? this.rangeLowerBound : this.rangeHigherBound;

    textInput.value = isMin
      ? Math.max(
          Math.min(
            parseInt(textInput.value),
            parseInt(otherTextInput.value || textInput.max) - 1
          ),
          textInput.min
        )
      : Math.min(
          Math.max(
            parseInt(textInput.value),
            parseInt(otherTextInput.value || textInput.min) + 1
          ),
          textInput.max
        );

    rangeInput.value = textInput.value;
    this.updateRangeStyle(rangeInput, type);

    if (this.facetFiltersForm) {
      this.facetFiltersForm.onSubmitHandler(event);
    }
  }

  handleRangeChange(type, event) {
    event.stopPropagation();
    const textInput =
      type === "min" ? this.textInputLowerBound : this.textInputHigherBound;
    textInput.value = event.target.value;
    textInput.dispatchEvent(new Event("change", { bubbles: true }));
  }

  handleRangeInput(type, event) {
    const isMin = type === "min";
    const textInput = isMin
      ? this.textInputLowerBound
      : this.textInputHigherBound;
    const otherTextInput = isMin
      ? this.textInputHigherBound
      : this.textInputLowerBound;

    event.target.value = isMin
      ? Math.min(
          parseInt(event.target.value),
          parseInt(otherTextInput.value || event.target.max) - 1
        )
      : Math.max(
          parseInt(event.target.value),
          parseInt(otherTextInput.value || event.target.min) + 1
        );

    textInput.value = event.target.value;
    this.updateRangeStyle(event.target, type);
  }

  updateRangeStyle(rangeInput, type) {
    const percentage =
      (parseInt(rangeInput.value) / parseInt(rangeInput.max)) * 100;
    rangeInput.parentElement.style.setProperty(
      `--range-${type}`,
      `${percentage}%`
    );
  }
}

customElements.define("price-range", PriceRange);
